import * as Constants from "./constants";
/**
 * Actions pour la gestion de la boîte de dialogue de confirmation
 * @category Dialogs
 * @hideconstructor
 */

var ConfirmDialogStoreAction = /*#__PURE__*/function () {
  function ConfirmDialogStoreAction() {}

  /**
   * Ouverture de la boîte de dialogue
   * @param {string} message Message à afficher
   * @param {function} onValid Fonction appelée après validation
   * @param {function} onCancel Fonction appelée après annulation
   */
  ConfirmDialogStoreAction.openConfirmDialog = function openConfirmDialog(message, onValid, onCancel) {
    if (onCancel === void 0) {
      onCancel = null;
    }

    return {
      type: Constants.OPEN_DIALOG,
      value: {
        message: message,
        onValid: onValid,
        onCancel: onCancel
      }
    };
  }
  /**
   * Fermeture de la boîte de dialogue
   */
  ;

  ConfirmDialogStoreAction.closeConfirmDialog = function closeConfirmDialog() {
    return {
      type: Constants.CLOSE_DIALOG
    };
  };

  return ConfirmDialogStoreAction;
}(); // Exports


export var openConfirmDialog = ConfirmDialogStoreAction.openConfirmDialog;
export var closeConfirmDialog = ConfirmDialogStoreAction.closeConfirmDialog;